export const ReservationStatusConstant = () => { return {
    IN_PROGRESS: { id: 1 },
    CREATED: { id: 2 },
    FAILED: { id: 3 },
    CANCELED: { id: 4 } 
}};